<template>
  <div class="w-100 h-100 position-absolute shadow-bottom-container"
    v-observe-visibility="{
        callback: visibilityChanged,
        intersection: {
            threshold: 0.7,
        },
    }"
  >
    <div class="shadow-bottom">
      <div class="shadow-bottom-row" v-if="isVisible"></div>
      <div class="row m-0 w-100">
        <div class="col p-0">
          <a v-if="name" :href="url" :aria-label="name">
            <span class="name-label" v-html="name"/>
            <span v-if="extraField" class="name-label extra" v-html="extraField"/>
          </a>
          <ul v-if="comboList && zoomed" class="item-list">
            <li v-if="comboList.firstProductName"> <span class="list-decoration"/> {{ comboList.firstProductName }} </li>
            <li v-if="comboList.secondProductName"> <span class="list-decoration"/> {{ comboList.secondProductName }} </li>
          </ul>
        </div>
        <div class="col-auto p-0">
          <p class="price-strikethrough">{{priceCrossed}}</p>
          <p class="price-label">{{price}}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BlockShadow",
  props: {
      url: {
          type: String,
          default: '',
      },
      name: {
          type: String,
          default: null,
      },
      extraField: {
          type: String,
          default: null,
      },
      priceCrossed: {
          type: String,
          default: null,
      },
      price: {
          type: String,
          default: null,
      },
      comboList: {
          type: Object,
          default: null,
      },
      zoomed: {
          type: Boolean,
          default: false,
      },
    
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    visibilityChanged(isVisible) {
      this.isVisible = isVisible;
    },
  },
};
</script>